'use client'

import { useEffect, useRef } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/context/AuthContext'
import { AppSelector } from '@/components/AppSelector'

// Development mode: temporarily skip login check
const SKIP_LOGIN = false

export default function HomePage() {
  const router = useRouter()
  const { isReady, isGuest, appRole, refreshMe } = useAuth()
  const refreshedRef = useRef(false)

  useEffect(() => {
    if (SKIP_LOGIN) return
    if (!isReady) return
    if (isGuest) {
      router.push('/login')
      return
    }
    // Refresh roles from backend once per page load so admin role changes take
    // effect without forcing a re-login.
    if (!refreshedRef.current) {
      refreshedRef.current = true
      void refreshMe()
    }
  }, [isReady, isGuest, refreshMe, router])

  // Students are routed straight into GradeAI; the AppSelector grid is for
  // TAs / teachers / admins who actually have multiple destinations.
  useEffect(() => {
    if (SKIP_LOGIN) return
    if (!isReady || isGuest) return
    if (appRole === 'student') {
      router.replace('/plugins/gradeai')
    }
  }, [isReady, isGuest, appRole, router])

  if (!isReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-muted-foreground animate-pulse">Loading...</div>
      </div>
    )
  }

  if (SKIP_LOGIN) {
    return <AppSelector />
  }

  if (isGuest) {
    return null
  }

  if (appRole === 'student') {
    // Already redirecting; render nothing to avoid a flash of the selector.
    return null
  }

  return <AppSelector />
}
